module.exports = __webpack_public_path__ + "img/news25-0.8d91c602.png";